// Auto-generated entry for verification// import './../../verification.scss';

// Includes general styles and scripts
import './initial';

import '../js/src/vendor/script/opacc.account';
